<template>
  <section class="sidebar-section detail-sidebar" id="">
    <b-sidebar
    :style="style"
      @hidden="()=>{
        $emit('update:isShow', false)
        $emit('close')
      }"
      v-model="isShow"
      bg-variant="white"
      right
      backdrop
      shadow
      no-header
      :width="width || '60%'"
    >
    <div class="sidebar-section__header d-flex">
        <div class="sidebar-section__header--title w-50">
          <h4 class="mb-0 p-1 text-primary text-truncate">
           {{ title ?  $t(title): 'Detail' }}
          </h4>
        </div>
        <div
        
          class="sidebar-section__header--icon w-50 d-flex align-items-center justify-content-end"
        >
         <!--  <ez-icon
          v-if="!disabledAction"
            @click="$emit('delete')"
            icon="ezAr-icon-trash"
            size="24"
            class="cursor-pointer mx-50"
            color="#EA5455"
          /> -->
          <ez-icon
            icon="ezAr-icon-x"
            size="24"
            class="cursor-pointer mx-50"
            color="#114A9F"
            @click="$emit('update:isShow',false)"
          />
        </div>
      </div>
      <slot> </slot>
    </b-sidebar>
  </section>
</template>
<style lang="scss">
.sidebar-section {
  &__header {
    background: linear-gradient(
        0deg,
        rgba(17, 74, 159, 0.12),
        rgba(17, 74, 159, 0.12)
      ),
      #ffffff;
  }
  ::v-deep .tabs {
    .nav-tabs {
      background: rgba(193, 193, 193, 0.12);
      li a {
        padding: 13px;
      }
    }
  }
  .divider {
    height: 12px;
    background-color: rgba(193, 193, 193, 0.12);
  }
}
</style>
<script>
export default {
  props: {
    width:String,
    disabledAction: Boolean,
    title: String,
    isShow: Boolean,
  },
  name: "SidebarSection",
};
</script>
